import React, { useEffect, useState } from "react";

import { useSelector,useDispatch } from "react-redux";
import { Link } from "react-router-dom";

interface categoryType {
  _id: string;
  name: string;
}

const Category = (props: any) => {

  


  return (
    <div className="shop_sidebar_area">

            <div className="widget catagory mb-50">
                <h6 className="widget-title mb-30">Categories</h6>

                <div className="catagories-menu">
                    <ul>
                    <li onClick={() => props?.setCategoryName("all")}>
                          <a href="#">
                          All
                          </a>
                    </li>
                    {props.categories?.map((item: categoryType, index:any) => (
                        <li key={index} onClick={() => props?.setCategoryName(item?.name)}>
                          <a href="#">
                          {item?.name}
                          </a>
                          </li>
                    ))}
                    </ul>
                </div>
           </div>
      </div>
    )
};

export default Category;
